import React from "react";
import { IPanelProps, Panel } from "core/decorators/Panel";
import FFHTMLWidget from "./FFHTMLWidget";
import { BlockView } from "common/views/block/BlockView.view";
import { DialogView } from "common/views/dialog/Dialog.view";
import EntityForm from "core/components/EntityForm";
import { ForumToaster } from "panels/forum/forumActions";
import { Intent } from "@blueprintjs/core";
import FFHTMLWidgetConfig from "panels/FFHTMLWidget/FFHTMLWidgetConfig";
import InstitutionHTMLComponent from "./InstitutionHTMLComponent";
export interface FFHTMLWidgetPanelState {
	isOpen: boolean; // for dialog edit view
	toggleOpen: boolean;
	mutationFlag: boolean; //get Toggles in-case of mutation to get each new graph-QL Request
	institution: string;
	queryVersion: number;
}

@Panel({ id: "InstitutionFFHTMLWidget", configClass: FFHTMLWidgetConfig, pageParams: true })
export default class FFHTMLWidgetPanel extends React.Component<
	IPanelProps<FFHTMLWidgetConfig>,
	FFHTMLWidgetPanelState
> {
	private frameRef: any;
	private attributeToConvert = 'fftext';

	public state: FFHTMLWidgetPanelState = {
		isOpen: false,
		toggleOpen: false,
		mutationFlag: false,
		institution: this.props.pageParams.institution, // this acts as prevInstitution
		queryVersion: Date.now()
	};
	

	constructor(props: IPanelProps<FFHTMLWidgetConfig>) {
		super(props);
		this.frameRef = React.createRef();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.pageParams.institution !== this.props.pageParams.institution) {
		  this.setState({
			institution: this.props.pageParams.institution,
			queryVersion: Date.now(), // or increment a counter
		  });
		}
	  }


	
	private toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });

	private showDialog = (data: FFHTMLWidget) => {
		if (this.state.isOpen) {
			return (
				<DialogView
					isOpen={this.state.isOpen}
					onClose={this.toggleOpen}
					viewKey="dialog"
				>
					<BlockView viewKey="card-primary">
						<EntityForm
							instance={data}
							clazz={FFHTMLWidget}
							afterSave={data => {
								ForumToaster.show({
									intent: Intent.SUCCESS,
									message: "Saved successfully !!"
								});
								this.setState(prev => ({
									isOpen: false,
									mutationFlag: !prev.mutationFlag
								}));
							}}
							config={{...this.props.config}}
							attributeToConvert={this.attributeToConvert}
						/>
					</BlockView>
				</DialogView>
			);
		} else {
			return null;
		}
	};

	public render() {
		const { instance, language, pageParams } = this.props;
		const queryArgs = {
			id: `${instance}-${this.state.queryVersion}`,
			instance: pageParams.institution,
			lang: language,
			mutationFlag: this.state.mutationFlag
		};
		return (
			<InstitutionHTMLComponent
				key={pageParams.institution}
				queryArgs={queryArgs}
				showDialog={this.showDialog}
				toggleOpen={this.toggleOpen}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/institutions/InstitutionHTMLWidget.panel.tsx